import React from "react";
import { Box, Container, SimpleGrid, Text, Icon, VStack, Circle } from "@chakra-ui/react";
import { CalendarDays, Building2, Handshake, Users } from "lucide-react";
import { useText } from "../../i18n/lang";

const TEXT = {
  en: ["years on the Romanian market", "corporate customers", "partner travel agencies", "professionals in our team"],
  ro: ["ani pe piața din România", "clienți corporate", "agenții de turism partenere", "profesioniști în echipă"],
};

const STATS = [
  { icon: CalendarDays, value: "20+" },
  { icon: Building2, value: "100+" },
  { icon: Handshake, value: "250+" },
  { icon: Users, value: "30+" },
];

const HomeStats = () => {
  const labels = useText(TEXT);

  return (
    <Container maxW="container.xl" position="relative" mt={{ base: -16, md: -20 }} zIndex={1}>
      <SimpleGrid
        columns={{ base: 2, md: 4 }}
        bg="white"
        borderRadius="2xl"
        boxShadow="0 20px 45px -20px rgba(15, 40, 80, 0.35)"
        borderWidth="1px"
        borderColor="gray.100"
        overflow="hidden"
      >
        {STATS.map((stat, index) => (
          <VStack
            key={stat.value + index}
            spacing={2}
            py={{ base: 6, md: 8 }}
            px={4}
            textAlign="center"
            borderColor="gray.100"
            borderRightWidth={{ base: index % 2 === 0 ? "1px" : 0, md: index < 3 ? "1px" : 0 }}
            borderBottomWidth={{ base: index < 2 ? "1px" : 0, md: 0 }}
          >
            <Circle size="44px" bg="blue.50">
              <Icon as={stat.icon} boxSize={5} color="blue.500" />
            </Circle>
            <Text fontFamily="Montserrat" fontWeight="700" fontSize={{ base: "2xl", md: "3xl" }} color="blue.600" lineHeight="1.1">
              {stat.value}
            </Text>
            <Box color="gray.600" fontSize={{ base: "sm", md: "md" }} lineHeight="1.4">
              {labels[index]}
            </Box>
          </VStack>
        ))}
      </SimpleGrid>
    </Container>
  );
};

export default HomeStats;
